/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Container, Box, Grid, Hidden, Button, makeStyles, Dialog, IconButton } from "@material-ui/core";
import AppointmentCard from "../AppointmentCard";
import {colorPrimary} from "../../Constants/theme";
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import {servicesChat} from "../../Constants/serviceType";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {setSelectedAppointment as setAppointmentToRedux} from "../../redux/appointment/appointment.actions";
import {clearMessages, deleteInter, setChat} from "../../redux/chat/chat.actions";
import {setEquals} from "../../redux/chat/chat.reducers";

const useStyle = makeStyles(() => ({
    buttons: {
        width: 184,
        marginBottom: 10,
        marginRight: 13,
        lineHeight: "16px"
    },
    cancelButton: {
        width: 184,
        marginBottom: 10,
        marginRight: 13,
        border: "1.5px solid #FF6D6D",
        color: "#EA5858"
    }
}));

const AppointmentCardContainer = (props) => {
    const { item, vetProfiles, setModalVisibility, setSelectedAppointment, showNotes } = props;
    const history = useHistory();
    const classes = useStyle();
    const [timeUp, setTimeUp] = useState(1000);
    const [equalsScheduled, setEqualsScheduled] = useState(false);
    const [appointmentDone, setAppointmentDone] = useState(false);
    const [showChat, setShowChat] = useState(false);
    const [buttonText, setButtonText] = useState("Join Appointment");
    const { vetUserId, id, scheduledDate, type } = item;
    const vetProfile = vetProfiles.find(({ userId }) => userId === vetUserId);
    const dispatch = useAppDispatch();
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const user = useSelector((state: RootState) => state?.user);
    const handleAppointmentAfterAnHour = () => {
        if (!servicesChat.includes(item.type)) {
            setShowChat(false);
        } else {
            setButtonText("View Transcript");
            setAppointmentDone(true);
            setShowChat(true);
        }
    };

    useEffect(() => {
        const scheduledTime = moment(scheduledDate);
        const timeDiff = scheduledTime.diff(moment(), "minutes");
        if(timeDiff < 0) {
            if(Math.abs(timeDiff) >= 60){
                handleAppointmentAfterAnHour();
            } else {
                setShowChat(true);
                setEqualsScheduled(true);
                setTimeout(() => {
                    handleAppointmentAfterAnHour();
                }, (60 - Math.abs(timeDiff)) * 60 * 1000);
            }
        }
        if(timeDiff >= 0 && timeDiff <= 35791){
            setTimeout(() => {
                setShowChat(true);
                setEqualsScheduled(true);
                setButtonText("Join Appointment");
            }, (timeDiff - 5) * 60000);
        }
    }, [item]);

    useEffect(() => {
        if(equalsScheduled) {
            setTimeout(() => {
                handleAppointmentAfterAnHour();
            }, 3600 * 1000);
        }
    }, [equalsScheduled]);

    return (
        <Box key={id}>
            <AppointmentCard
                cardData={{
                    appointmentData: item,
                    vetProfile
                }}
                showNotes={showNotes}
                over={false}
            />
            <Grid container wrap="wrap" justify="flex-start" alignItems="center">
                <Button
                    className={classes.buttons}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        dispatch(deleteInter());
                        dispatch(clearMessages());
                        //handleChatData(true, {item, vetProfile}, appointmentDone);
                        dispatch(setChat({data: {item, vetProfile}, over: appointmentDone}));
                        dispatch(setEquals(equalsScheduled));
                        history.push("/chat/?isJoin=true");
                        dispatch(setAppointmentToRedux(item));
                    }}
                    disableElevation
                    disabled={!showChat || item.pending}
                >
                    {item.pending ? "Pending" : buttonText}
                </Button>
                {	user.role !== "OWNER" &&
					<>
					    <Button
					        className={classes.buttons}
					        variant="contained"
					        style={{color: colorPrimary}}
					        onClick={() => {
					            dispatch(setAppointmentToRedux(item));
					            history.push({pathname: "/apointmentPrescriptions", state: {appointmentId: id, redirectBack: true}});
					        }}
					        disableElevation
					        disabled={item.pending}
					    >
                            {item.type.includes("ADVICE") ? "OTC" : "Prescription / OTC"}
					    </Button>
					    <Button
					        className={classes.buttons}
					        variant="contained"
					        style={{color: colorPrimary}}
					        onClick={() => {
					            dispatch(setAppointmentToRedux(item));
					            history.push({pathname: "/apointmentNotes", state: {appointmentId: id, afterAppt: false}});
					        }}
					        disableElevation
					        disabled={item.pending}
					    >
					Notes
					    </Button>
					</>
                }
                {	user.role === "OWNER" &&
					<Button
					    className={classes.cancelButton}
					    variant="contained"
					    onClick={() => {
					        dispatch(setAppointmentToRedux(item));
					        setModalVisibility(true);
					    }}
					    disableElevation
					>
					Cancel
					</Button>
                }
            </Grid>
        </Box>
    );
};

export default AppointmentCardContainer;
